import React from "react";
import { colors } from "utils/styles";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
// import Container from "react-bootstrap/Container";

// import Stack from "react-bootstrap/Stack";
import renderItem from "utils/renderItem";
export default function StatsListItem(props) {
	const statItem = props.statItem?.fields;
	if (!statItem) {
		return <></>;
	}
	const { statDescription, statValue, leftToRight = false } = statItem;

	return (
		<Row className={`py-1 align-items-end g-0`}>
			<Col className="pb-1 me-2" xs={"auto"}>
				{renderItem(leftToRight ? statDescription : statValue)}
			</Col>
			<Col className="pb-2 ">
				<div style={{}} className="statsLine"></div>
			</Col>
			<Col className="ms-2" xs={leftToRight ? "auto" : "4"}>
				{renderItem(leftToRight ? statValue : statDescription)}
			</Col>

			<style jsx>{`
				.statsTitle {
					margin: 0;
					font-size: 17px;
					font-family: "Open Sans";
					line-height: 23px;
					font-weight: bold;
					color: ${colors.darkBlue};
					letter-spacing: 0px;
				}

				.statsLine {
					border-top: 2px dotted ${colors.gray};
				}

				.statsNumber {
					margin: 0;
					font-size: 46px;
					font-family: "Open Sans";
					line-height: 60px;
					font-weight: bold;
					color: ${colors.darkBlue};
					letter-spacing: 0px;
				}

				@media screen and (max-width: 1199px) {
					.statsNumber {
						font-size: 30px;
						line-height: 40px;
					}

					.statsTitle {
						font-size: 16px;
						line-height: 22px;
					}
				}
			`}</style>
		</Row>
	);
}
